import { gql } from '@apollo/client';

export const CREATE_CATEGORY = gql`
    mutation CreateCategory($input:CreateCategoryInput) {
    createCategory(input: $input) {
        data {
            categories {
                created_at
                description
                folder_id
                group_id
                id
                name
                updated_at
                category_order
                group {
                    created_at
                    description
                    group_order
                    folder_id
                    id
                    name
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

export const UPDATE_CATEGORY = gql`
   mutation UpdateCategory($input:UpdateCategoryInput) {
    updateCategory(input: $input) {
        data {
            category {
                created_at
                description
                folder_id
                group_id
                id
                name
                updated_at
                category_order
                group {
                    created_at
                    description
                    group_order
                    folder_id
                    id
                    name
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

export const DELETE_CATEGORY = gql`
    mutation DeleteCategory($category_id:UUID, $folder_id: String) {
        deleteCategory(category_id: $category_id, folder_id: $folder_id) {
            error {
                message
            }
            data {
                message
            }
        }
    }
`;